import createSvgIcon from "./utils/create_icon"

const Image = createSvgIcon(<path clipRule="evenodd" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm1 12a1 1 0 0 1-1-1v-1l4.293-4.293a1 1 0 0 1 1.414 0L13.5 14.5l1.793-1.793a1 1 0 0 1 1.414 0L20 16a1 1 0 0 1-1 1zm12.5-7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" fill="currentColor" fillRule="evenodd" />, "Image")
export default Image
